import pdfjs from "pdfjs-dist";
import { rotateCanvas } from "canvas-utils";

//TODO - is there a better way of doing this?
// see https://github.com/mozilla/pdf.js/blob/master/examples/webpack/webpack.config.js
pdfjs.PDFJS.workerSrc = "/node_modules/pdfjs-dist/build/pdf.worker.js";

//1169 x 827  = A4 @ 100dpi
//2339 x 1653 = A4 @ 200dpi
//3508 x 2480 = A4 @ 300dpi
export const pageToCanvas = function (page, maxWidth = 1653, maxHeight = 2339, forcePortrait = true) {
  // maxWidth refers to shortest side (might be portrait)
  // maxHeight refers to longest side (might be portrait)
  if (maxWidth > maxHeight) { //swap so width is allways shortest
    [maxWidth, maxHeight] = [maxHeight, maxWidth];
  }

  var promise = new Promise(function (resolve, reject) {
    var canvas = document.createElement("canvas");
    var origViewport = page.getViewport(1);
    var origWidth = origViewport.width;
    var origHeight = origViewport.height;
    let isLandscape = origWidth > origHeight;
    if (isLandscape) { //if landscape, swap max W&H
      [maxWidth, maxHeight] = [maxHeight, maxWidth];
    }
    //from this point maxWidth refers to horizontal dimension (not necessarily shortest)

    // scale to fit a max dimensions (fill width or height)
    var scale = maxWidth / origWidth;
    if ((origWidth / origHeight) < (maxWidth / maxHeight)) {
      scale = maxHeight / origHeight;
    }

    var viewport = page.getViewport(scale);
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    var context = canvas.getContext("2d");
    var renderContext = {
      canvasContext: context,
      viewport: viewport
    };
    page.render(renderContext)
      .then(function () {
        if (isLandscape) {
          return rotateCanvas(canvas);
        } else {
          return canvas;
        }
      })
      .then(function (canvas) {
        resolve(canvas);
        //TODO reject(Error("It broke"));
      });
  });
  return promise;
};


// returns base64 string as promise
export const pageToImageData = function (page, maxWidth = 1653, maxHeight = 2339) {
  return pageToCanvas(page, maxWidth, maxHeight).then(function (canvas) {
    return canvas.toDataURL("image/jpeg");
  });
};

//takes a url and returns a pdfjs object (as promise)
export const urlToPdf = function (url) {
  return pdfjs.getDocument(url);
};

//converts file (from fileinput) to pdfjs object (as promise)
export const fileToPdf = function (file) {
  var fileReader = new FileReader();
  var promise = new Promise(function (resolve, reject) {
    fileReader.onload = function () {
      var typedarray = new Uint8Array(this.result);
      resolve(pdfjs.getDocument(typedarray));
    };
    fileReader.onerror = function (e) {
      reject(e);
    };
  });
  fileReader.readAsArrayBuffer(file);
  return promise;
};

//returns an array of pages from a pdf as a promise
export const pdfToPages = function (pdf) {
  let promises = [];
  for (let i = 1; i <= pdf.numPages; i++) {
    promises.push(pdf.getPage(i));
  }
  return Promise.all(promises);
};

// returns array of base64 strings as promise
export const pdfToImageDataArray = function (pdf, maxWidth = 1653, maxHeight = 2339) {
  return pdfToPages(pdf).then(function (pages) {
    let promises = pages.map(page => pageToImageData(page, maxWidth, maxHeight));
    return Promise.all(promises);
  });
};

export const fileToImageDataArray = function (file, maxWidth = 1653, maxHeight = 2339) {
  return fileToPdf(file).then(function (pdf) {
    return pdfToImageDataArray(pdf, maxWidth, maxHeight);
  });
};

export const urlToImageDataArray = function (url, maxWidth = 1653, maxHeight = 2339) {
  return urlToPdf(url).then(function (pdf) {
    return pdfToImageDataArray(pdf, maxWidth, maxHeight);
  });
};

